<template>
  <div class="messengers-settings-page">
    <div class="messengers-settings-page__title">{{ $t('settings.messengers_settings') }}</div>
    <div
      class="messengers-settings-page__subtitle"
    >{{ $t('settings.select_messengers_for_notifications') }}</div>
    <messengers-settings></messengers-settings>
  </div>
</template>
<script>
  import messengersSettings from '@/components/Settings/messengers.vue';

  export default {
    name: 'MessengersSettingsPage',
    components: {messengersSettings}
  }
</script>
<style lang="scss">
.messengers-settings-page {
  max-width: 500px;
  padding: 25px 20px;
  background: #fff;
  box-shadow: 0px 4px 20px rgba(53, 49, 81, 0.06);
  border-radius: 12px;

  &__title {
    margin-bottom: 9px;
    font-size: 18px;
    font-weight: 700;
  }
  &__subtitle {
    margin-bottom: 25px;
    color: #838A99;
    font-weight: 500;
  }
}
</style>